import React, { PropTypes } from 'react';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

const HelpPage = ({ children }) => (
  <div className="l-content help-page">
    <Meta
      title="Help"
      meta={[
        { name: "robots", content: "index,follow" },
        { name: "description", content: "Frequently asked questions about crowdspring - the world's #1 marketplace for logo design, web design and crowdsourced writing projects." },
        { name: "keywords", content: "crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing" }
      ]}
      link={[{ rel: "canonical", href: getCanonicalURL("/help/") }]} />
    <div id="content">
      {children}
    </div>
  </div>
);

HelpPage.propTypes = {
  children: PropTypes.any,
};

export default HelpPage;



// WEBPACK FOOTER //
// ./help/components/index.jsx